import { OnInit } from '@angular/core';
import { SummaryService } from '../services/summary.service';
import { Globals } from '../objects/Globals';
import { Router } from '@angular/router';
import { ThemeSettingService } from '../services/theme-setting.service';
import { WorkspaceService } from '../services/workspace.service';
var PendingitemComponent = /** @class */ (function () {
    function PendingitemComponent(summaryService, globals, router, themeSettingService, workspaceService) {
        this.summaryService = summaryService;
        this.globals = globals;
        this.router = router;
        this.themeSettingService = themeSettingService;
        this.workspaceService = workspaceService;
        this.isBusy = false;
        this.config = {
            direction: 'horizontal',
            slidesPerView: 4,
            keyboard: true,
            navigation: true,
            pagination: false,
            spaceBetween: 0,
            breakpoints: {
                380: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 3
                },
                1280: {
                    slidesPerView: 4
                }
            }
        };
        this.filledSpace = 0;
    }
    PendingitemComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loaderConfig = this.themeSettingService.getTheme();
        if (this.globals.Session) {
            this.isBusy = true;
            this.summaryService.createSummaryPendingItems().subscribe(function (result) {
                _this.componentId = result;
                _this.summaryService.getSummaryPendingItems(result).subscribe(function (pendingList) {
                    _this.isBusy = false;
                    _this.pendingItems = [];
                    var items = JSON.parse(pendingList);
                    if (items) {
                        items = items.filter(function (x) { return x.ItemCount != "0"; });
                        _this.pendingItems = items.sort(_this.sortPendingItems);
                    }
                }, function (error) {
                    _this.isBusy = false;
                });
            }, function (error) {
                _this.isBusy = false;
            });
        }
    };
    PendingitemComponent.prototype.sortPendingItems = function (a, b) {
        if (a.ItemSequence < b.ItemSequence)
            return -1;
        if (a.ItemSequence > b.ItemSequence)
            return 1;
        return 0;
    };
    PendingitemComponent.prototype.selectPending = function (type) {
        var _this = this;
        this.isBusy = true;
        this.summaryService.selectSummaryPendingItems(this.componentId, type).subscribe(function (result) {
            _this.handleWorkflowReturn(result);
            _this.isBusy = false;
        }, function (error) {
            _this.isBusy = false;
        });
    };
    PendingitemComponent.prototype.prevPage = function () {
    };
    PendingitemComponent.prototype.nextPage = function () {
    };
    PendingitemComponent.prototype.handleWorkflowReturn = function (result) {
        var command = JSON.parse(result);
        switch (command.ReturnType) {
            case 0:// navigate
                if (command.Arguments) {
                    var path = [];
                    command.Arguments.forEach(function (element) {
                        path.push(element);
                    });
                    this.router.navigate(path);
                }
                break;
        }
    };
    return PendingitemComponent;
}());
export { PendingitemComponent };
